import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';

class SharedStoryBtn extends Component {

  handleClick = (e) => {
    e.preventDefault();
    this.props.push('/leader-spotlight');
  }

  render() {

    return(
      <div className="sharedStoryBtn home-connectButton">
        <Link to="" onClick={this.handleClick.bind(this)}>Share your story</Link>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    Link,
    push
  }
)(SharedStoryBtn);



// WEBPACK FOOTER //
// ./src/components/SharedStoryBtn.jsx